import React, { useEffect, useState } from 'react'
import { Controller } from 'react-hook-form';
import Select from 'react-select';
import clsx from 'clsx';
import { usePreferedCurrency } from '../../../../services/common/hooks/usePreferedCurrency';

interface PreferedCurrencyComponentProps {
    control: any,
    errors: any
}

interface OptionType {
    value: string,
    label: string
}

const PreferedCurrencyComponent: React.FC<PreferedCurrencyComponentProps> = ({ control, errors }) => {
    const defaultCurrency = { value: '', label: 'All Currencies' };
    const [optionsCurrency, setOptionsCurrency] = useState<OptionType[]>([]);
    const { data: currencies, isFetching, isError } = usePreferedCurrency();

    useEffect(() => {
        if (currencies) {
            setOptionsCurrency([
                defaultCurrency,
                ...currencies.data.map((currency) => ({ value: currency.value, label: currency.text }))
            ]);
        }
    }, [currencies]);

    return (
        <div className='form-group'>
            <label className='form-label'>Prefered Currency</label>
            <Controller
                control={control}
                name='preferred_currency'
                render={({ field }) => (
                    <Select
                        key={field.value}
                        {...field}
                        className={clsx('', { 'is-invalid': errors.preferred_currency })}
                        options={optionsCurrency}
                        value={optionsCurrency.find((currency) => currency.value === field.value)}
                        onChange={(selectedOption) => {
                            if (selectedOption) {
                                field.onChange(selectedOption.value);
                            }
                        }}
                        isLoading={isFetching}
                        isDisabled={isError}
                        defaultValue={defaultCurrency}
                    />
                )}
            />
            {errors.preferred_currency && <div className="invalid-feedback">{errors.preferred_currency.message}</div>}
        </div>
    )
}

export default PreferedCurrencyComponent